<template>
  <div class="container">
    <div class="heading">
      <p style="margin-bottom: 10px">{{ newData.label }}</p>
    </div>
    <div>
      <div class="main_inner">
        <div class="infoCard" v-for="options in newData.options">
          <div class="left">
            <img
              :src="selectedImages(options.additional_info.prepend_image)"
              alt="image"
              class="envImages"
            />
          </div>
          <div class="right">
            <p class="inner_heading" v-html="options.label"></p>
            <div class="contentFlex">
              <p class="inner_content">{{ options.description }}</p>
              <p class="inner_footer">{{ options.field_unit }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { solarCalculatorStore } from "../../../store/solarCalculator";
import Coal from "../../assets/coalBurnt.svg";
import Coal2 from "../../assets/coalBurnt2.svg";
import co2 from "../../assets/co2.svg";
import Carbon2 from "../../assets/co22.svg";
import Tree from "../../assets/Plant.svg";
import Tree2 from "../../assets/Plant2.svg";

const store = solarCalculatorStore();
const calculatorData = store.CALCULATOR_DATA_STATE;

const props = defineProps({
  heading: {
    type: String,
    required: true,
  },
  newData: Object,
});

const carbon = ref(co2);
const carbon2 = ref(Carbon2);
const coalBurnt = ref(Coal);
const coalBurnt2 = ref(Coal2);
const plantTree = ref(Tree);
const plantTree2 = ref(Tree2);

const selectedImages = (data) => {
  switch (data) {
    case "carbonImage":
      if (!calculatorData.isTata) {
        return carbon2.value;
      }
      return carbon.value;
      break;
    case "treeImage":
      if (!calculatorData.isTata) {
        return plantTree2.value;
      }
      return plantTree.value;
      break;
    case "coalBurnImage":
      if (!calculatorData.isTata) {
        return coalBurnt2.value;
      }
      return coalBurnt.value;
      break;
    default:
      return null;
      break;
  }
};
</script>

<style scoped>
.heading {
  color: var(--777, #777);
  font-family: Arial;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border-bottom: 2px solid var(--CCC, #ccc);
  margin-top: 24px;
  margin-bottom: 5px;
}
.infoCard {
  display: flex;
  width: 100%;
  height: 171px;
  /* padding: 0px 16px; */
  gap: 15px;
  border-radius: 8px;
  border: 1px solid var(--CCC, #ccc);
  margin-top: 10px;
}

.main_inner {
  display: flex;
  align-items: center;
  gap: 16px;
}

.left {
  display: flex;
}

.right,
.contentFlex {
  display: flex;
  flex-direction: column;

  justify-content: space-evenly;
}

.inner_heading {
  color: var(--777, #777);
  font-family: Arial;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  width: 90%;
}
.inner_content {
  color: var(--grey-grey-5, #0d0d0d);
  font-family: Arial;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.inner_footer {
  color: rgba(34, 34, 34, 1);
  font-size: 20px;
  font-weight: 400;
}

.infoHolder {
  color: var(--arka-text, #141414);
  font-family: Switzer;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

@media (max-width: 1180px) {
  .main_inner {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-direction: column;
  }

  .infoCard {
    gap: 15px;
  }
}

@media (max-width: 600px) {

.heading {
  font-size: 16px;
  border-bottom: none;
  margin-top: 24px;
}

.infoCard {
  height: auto;
  margin-top: 0px;
}

.right {
  justify-content: center;
  gap: 8px;
  width: 100%;
}

.contentFlex {
  flex-direction: row;
  gap: 4px;
  justify-content: flex-start;
 }

.inner_heading {
  font-size: 14px;
}

.inner_content {
  font-size: 20px;
}

.inner_footer {
  font-size: 16px;
}

.envImages {
  max-width: 90px;
}

}
</style>
